// Local translations
export const T = {
  en_GB: {
    selectAnOption: "Select an option",
    fieldRequired: "This field is required",
    saveFailed: "Failed to save the answer. Please try again.",
  },
  nb_NO: {
    selectAnOption: "Velg et alternativ",
    fieldRequired: "Dette feltet er påkrevd",
    saveFailed: "Kunne ikke lagre svaret. Vennligst prøv igjen.",
  },
} as const;
